export default "__VITE_ASSET__BkfoUJGa__"